import React from 'react';
import { Redirect } from 'react-router-dom';
import { ajaxJson } from 'imports/ajax';
import * as auth from 'imports/auth';
import history from 'imports/history';


export default function MainComponent() {
    if (auth.isLogin()) {
        ajaxJson.get('/users/programs').then((res) => {
            const program = res.data.filter(item => (item.status === "started"))[0];
            if (program) {
                history.replace(`/execute/program/${program['uid']}`);
            } else {
                history.replace('home');
            }
        }).catch(() => {
            history.replace('home');
        })
        return (
            <div id="loading">
                <img src="/images/logo.svg" alt="درایت derayat" />
                <div className="spinner"></div>
            </div>
        )
    } else {
        return <Redirect to="home" />
    }
}

